"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Icon_1 = __importDefault(require("../Icon/Icon"));
var genIcon_1 = __importDefault(require("../../utils/genIcon"));
var BelowText_1 = __importDefault(require("../BelowText/BelowText"));
var reserveSpace_1 = __importDefault(require("../../utils/reserveSpace"));
var localization_1 = require("@scuf/localization");
var Search_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Search"));
var SearchRender = /** @class */ (function (_super) {
    __extends(SearchRender, _super);
    function SearchRender(props) {
        var _this = _super.call(this, props) || this;
        _this.iconClickWrap = function () {
            var value = _this.state.value;
            var onIconClick = _this.props.onIconClick;
            _this.inputRef.focus();
            if (onIconClick) {
                onIconClick(value);
            }
        };
        _this.clearSearch = function () {
            _this.setState({ value: '' });
            if (_this.props.onResultClear) {
                _this.props.onResultClear();
            }
        };
        _this.resultRenderer = function (props) {
            if (_this.props.resultRenderer) {
                return _this.props.resultRenderer(props);
            }
            else if (props.icon) {
                return React.createElement("div", { key: props.title },
                    genIcon_1.default(props.icon, { className: 'result-icon', root: 'common' }),
                    props.title);
            }
            else {
                return React.createElement("div", { key: props.title }, props.title);
            }
        };
        _this.showClear = function (e, data) {
            _this.setState({ value: data.value });
            if (_this.props.onSearchChange) {
                _this.props.onSearchChange(data.value);
            }
        };
        _this.state = {
            value: props.value || '',
        };
        if (props.onSearchChange) {
            props.onSearchChange(props.value);
        }
        return _this;
    }
    SearchRender.prototype.componentDidUpdate = function (prevProps) {
        var value = this.props.value;
        if (value !== prevProps.value) {
            this.setState({ value: value || '' });
        }
    };
    SearchRender.prototype.render = function () {
        var _this = this;
        var _a = this.props, onResultSelect = _a.onResultSelect, onSearchChange = _a.onSearchChange, disabled = _a.disabled, pValue = _a.value, placeholder = _a.placeholder, resultRenderer = _a.resultRenderer, noResultsMessage = _a.noResultsMessage, error = _a.error, t = _a.t, lng = _a.lng, results = _a.results, helperText = _a.helperText, reserveSpace = _a.reserveSpace, onTextChange = _a.onTextChange, onIconClick = _a.onIconClick, className = _a.className, rest = __rest(_a, ["onResultSelect", "onSearchChange", "disabled", "value", "placeholder", "resultRenderer", "noResultsMessage", "error", "t", "lng", "results", "helperText", "reserveSpace", "onTextChange", "onIconClick", "className"]);
        var noResult = noResultsMessage ? noResultsMessage : t('No results found');
        var value = this.state.value;
        return (React.createElement("div", { className: this.genSearchClass() },
            React.createElement(Search_1.default, __assign({ input: { ref: function (r) { return _this.inputRef = r; } }, value: value, results: results, disabled: disabled, className: "ui-search " + className, placeholder: placeholder, onSearchChange: this.showClear, resultRenderer: this.resultRenderer, noResultsMessage: noResult }, rest, onResultSelect && { onResultSelect: function (e, data) { return onResultSelect(data.result); } })),
            React.createElement("div", { className: "search-icon", onClick: this.iconClickWrap },
                React.createElement(Icon_1.default, { root: "common", name: "search", size: "small" })),
            value && React.createElement("span", { onClick: this.clearSearch, className: "close-icon" },
                React.createElement(Icon_1.default, { root: "common", name: "close", size: "small" })),
            reserveSpace_1.default(this.props) && React.createElement(BelowText_1.default, { helperText: helperText, error: error })));
    };
    SearchRender.prototype.genSearchClass = function () {
        var classString = 'ui search-wrap';
        var _a = this.props, disabled = _a.disabled, error = _a.error;
        if (disabled) {
            classString += " disabled";
        }
        if (error) {
            classString += ' error';
        }
        return classString;
    };
    return SearchRender;
}(React.Component));
exports.SearchRender = SearchRender;
exports.default = localization_1.InjectLocalization(SearchRender);
